import "./Section.css";

type SectionProps = {
  nom: string;
};

function Section({ nom }: SectionProps) {
  return (
    <div className="titre-section">
      
      <h2>{nom}</h2>
    </div>
  );
}

export default Section;
